'use client'
import { I18NText } from '@/components/I18NText'
import { useRouter } from '@/lib/useRouter'
import { DropdownMenuItem } from '../../ui/dropdown-menu'

export const AddOrganizationItem = () => {
	const router = useRouter()

	return (
		<DropdownMenuItem
			className="text-xs overflow-hidden text-ellipsis whitespace-nowrap text-link focus:text-link"
			onClick={() => router.push('/onboard')}
		>
			<I18NText text="navbar.menu.addOrganization" />
		</DropdownMenuItem>
	)
}
